import * as React from 'react';
import EmbeddedPowerBIReport from '../../../../../components/Reporting';
import { ReportingTabProps } from '../../../../../types/reporting.type';

const LossReport: React.FunctionComponent<ReportingTabProps> = (props) => {
    const { reportName } = props;
    const LOSS_REPORT_ID = '3385eb0b-f95b-42de-9fc8-ece76e066e55';
    const LOSS_REPORT_WORKSPACE_ID = '5969b83e-5d39-4154-ad43-a016b71cd9e0';

    return (
        <>
            <EmbeddedPowerBIReport
                reportId={LOSS_REPORT_ID}
                workspaceId={LOSS_REPORT_WORKSPACE_ID}
                reportName={reportName}
                hideFilters
                waitForPrimary
            />
        </>
    );
};

export default LossReport;
